import React from 'react';
import UnderOver from "./Statistic/UnderOver";

const UnderOverTable = (props) => {

    return (
        <div className="odd-even-table">
            <div className="col header-div-title header-history-light text-uppercase">
                <span className="">{props.t("labels:keno.numberUnderOver")}</span>
            </div>
            <div
                className="col no-padding-div div-bg-gray lotto6-history-result lotto12-history-result fade-in">

                <div className="bet-grid-container">

                    <table
                        id="keno_result_post"
                        border="1"
                        cellPadding="0"
                        cellSpacing="0"
                        width="100%"
                        className="fade-in"
                    >
                        <tbody>
                        <UnderOver {...props}/>
                        </tbody>

                    </table>

                </div>

            </div>
        </div>
    );
};

export default UnderOverTable;